<template>
  <v-container
    fluid
    tag="section"
  >
    <v-card>
      <v-card-text>
        <v-row dense>
          <v-col
            cols="12"
            sm="3"
          >
            <skud-place-select />
          </v-col>
          <v-col
            cols="12"
            sm="2"
          >
            <v-btn
              color="primary"
              outlined
              :disabled="!place"
              @click="openCreate()"
            >
              <v-icon class="ml-3">
                mdi-plus
              </v-icon>
              <span class="mx-3">Создать токен</span>
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            sm="7"
            class="d-sm-flex justify-end"
          >
            <v-btn
              icon
              title="Настройка столбцов"
              @click="openSkudHeaders()"
            >
              <v-icon>mdi-view-column</v-icon>
            </v-btn>
            <v-btn
              icon
              title="Обновить"
              :disabled="!place"
              @click="load()"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-alert
          v-if="!place"
          type="info"
          outlined
          class="mt-4 mb-0"
        >
          Выберите место
        </v-alert>
        <v-data-table
          v-else
          :headers="headers.filter(a => a.show || a.active)"
          :items="items"
          :loading="loading"
          :footer-props="datatable_footer"
          no-data-text="Нет данных для отображения"
        >
          <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
            {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
          </template>
          <template v-slot:item.place_ids="{item}">
            <v-chip
              v-for="p in item.place_ids"
              :key="p"
              small
              class="mr-1"
            >
              {{ p }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{item}">
            <skud-actions-menu>
              <v-list-item @click="askDelete(item)">
                <v-list-item-content>
                  Удалить
                </v-list-item-content>
              </v-list-item>
            </skud-actions-menu>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="dialog_headers.show"
      persistent
      max-width="700px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Настройка столбцов</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            dense
            :items-per-page="10"
            :items="headers.filter(a => !a.show)"
            :headers="[{value: 'text', text: 'Название столбца'}, {value: 'active_temp', text: 'Отображение'}]"
            :footer-props="datatable_footer"
            no-data-text="Нет данных для отображения"
          >
            <template v-slot:item.active_temp="{item}">
              <v-checkbox v-model="item.active_temp" />
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            @click="saveSkudHeaders('skud_token')"
          >
            <span class="mx-4">Сохранить</span>
          </v-btn>
          <v-btn
            color="secondary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            @click="dialog_headers.show = false"
          >
            <span class="mx-4">Закрыть</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_create.show"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Новый consumer-токен</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="form.name"
            label="Имя"
            clearable
            dense
          />
          <v-autocomplete
            v-model="form.place_ids"
            :items="places"
            label="Места"
            multiple
            chips
            small-chips
            deletable-chips
            dense
            no-data-text="Нет мест"
          />
          <skud-date-field
            v-model="form.expires_at"
            label="Действует до"
            :outlined="false"
          />
          <v-text-field
            value="Чтение проходов"
            label="Режим"
            readonly
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            :loading="dialog_create.loading"
            :disabled="!form.place_ids.length"
            @click="create()"
          >
            <span class="mx-4">Создать</span>
          </v-btn>
          <v-btn
            color="secondary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            @click="dialog_create.show = false"
          >
            <span class="mx-4">Отмена</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_token.show"
      persistent
      max-width="700px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Токен создан</span>
        </v-card-title>
        <v-card-text>
          <v-alert
            type="warning"
            outlined
            dense
          >
            Токен показан один раз, сохраните его
          </v-alert>
          <v-textarea
            v-model="dialog_token.token"
            readonly
            outlined
            auto-grow
            rows="3"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            @click="copyToken()"
          >
            <span class="mx-4">Скопировать</span>
          </v-btn>
          <v-btn
            color="secondary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            @click="dialog_token.show = false"
          >
            <span class="mx-4">Закрыть</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_delete.show"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Удалить токен?</span>
        </v-card-title>
        <v-card-text>
          {{ dialog_delete.item ? (dialog_delete.item.name || dialog_delete.item.id) : '' }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            :loading="dialog_delete.loading"
            @click="doDelete()"
          >
            <span class="mx-4">Удалить</span>
          </v-btn>
          <v-btn
            color="secondary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            @click="dialog_delete.show = false"
          >
            <span class="mx-4">Отмена</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import SkudPlaceSelect from '@/views/skud/components/SkudPlaceSelect.vue'
import SkudDateField from '@/views/skud/components/SkudDateField.vue'
import SkudActionsMenu from '@/views/skud/components/SkudActionsMenu.vue'
import { headersMixin } from '@/views/skud/shared/modules/headers-mixin'
import { SkudConsumerTokenService } from '@/views/skud/shared/services/skud-consumer-token-service'

export default {
  name: 'SkudConsumerTokenList',
  components: {
    SkudPlaceSelect,
    SkudDateField,
    SkudActionsMenu
  },
  mixins: [headersMixin],
  data () {
    return {
      svc: null,
      items: [],
      loading: false,
      places: [],
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageOptions: [5, 10, 15, 30, 50]
      },
      headers: [
        { text: 'Действия', value: 'actions', show: true, sortable: false },
        { text: 'Имя', value: 'name', show: true },
        { text: 'Режим', value: 'mode_text', active: true, active_temp: true },
        { text: 'Источник', value: 'source_text', active: true, active_temp: true },
        { text: 'Места', value: 'place_ids', active: true, active_temp: true, sortable: false },
        { text: 'Создан', value: 'created_at', active: true, active_temp: true },
        { text: 'Действует до', value: 'expires_at', active: true, active_temp: true },
        { text: 'Последнее использование', value: 'last_used_at', active: true, active_temp: true },
        { text: 'Использований', value: 'use_count', active: true, active_temp: true }
      ],
      form: { name: null, place_ids: [], expires_at: null },
      dialog_create: { show: false, loading: false },
      dialog_token: { show: false, token: '' },
      dialog_delete: { show: false, loading: false, item: null }
    }
  },
  computed: {
    place () {
      return this.$store.state.skud_place
    }
  },
  watch: {
    place () {
      this.items = []
      if (this.place) this.load()
    }
  },
  mounted () {
    this.svc = new SkudConsumerTokenService()
    this.setDefaultSkudHeaders(this.$store.state.user.skud_token_headers)
    if (this.place) this.load()
  },
  methods: {
    async load () {
      if (!this.place) return
      this.loading = true
      const res = await this.svc.getTokens(this.place)
      this.loading = false
      if (this.svc.error) {
        this.$store.commit('snackbar', this.svc.error)
        return
      }
      this.items = res.tokens
    },
    openCreate () {
      this.form = { name: null, place_ids: [this.place], expires_at: null }
      this.dialog_create.show = true
      if (!this.places.length) {
        this.axios.post('/api/place/list', { id: null, page: 1, limit: -1 })
          .then(result => {
            if (result.data && !result.data.error && result.data.data) {
              this.places = result.data.data.map(p => ({ value: p.id, text: p.name }))
            }
          })
          .catch(e => console.log(e))
      }
    },
    async create () {
      const body = { place_ids: this.form.place_ids, mode: 0 }
      if (this.form.name) body.name = this.form.name
      if (this.form.expires_at) body.expires_at = this.form.expires_at
      this.dialog_create.loading = true
      const res = await this.svc.createToken(this.place, body)
      this.dialog_create.loading = false
      if (!res.ok) {
        this.$store.commit('snackbar', res.error || 'Ошибка создания токена')
        return
      }
      this.dialog_create.show = false
      this.dialog_token.token = res.data.token
      this.dialog_token.show = true
      this.load()
    },
    copyToken () {
      navigator.clipboard.writeText(this.dialog_token.token)
        .then(() => this.$store.commit('snackbar', 'Скопировано'))
        .catch(() => this.$store.commit('snackbar', 'Не удалось скопировать'))
    },
    askDelete (item) {
      this.dialog_delete.item = item
      this.dialog_delete.show = true
    },
    async doDelete () {
      this.dialog_delete.loading = true
      const res = await this.svc.deleteToken(this.place, this.dialog_delete.item.id)
      this.dialog_delete.loading = false
      if (!res.ok) {
        this.$store.commit('snackbar', res.error || 'Ошибка удаления токена')
        return
      }
      this.dialog_delete.show = false
      this.$store.commit('snackbar', 'Токен удалён')
      this.load()
    }
  }
}
</script>
